/**
 * Name: Burger
 */

import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";

export default class Burger extends Collapsible {
  static settings = {
    control: '.js-burger-control',
    target: '.js-burger-target',
    label: '.js-burger-label',
    isPersistent: true,
  };

  constructor (element, options = {}) {
    super(element, {
      ...Burger.settings,
      ...options,
    });

    this.label = element.querySelector(this.settings.label);
  }

  get isDisplayed () {
    return getComputedStyle(this.element).display !== 'none';
  }

  open () {
    super.open();
    document.querySelector('header').classList.add('is-open');
    document.querySelector('html').classList.add('no-scroll');

    this.target.focus();

    if (this.label) {
      this.label.textContent = "Fermer";
    }

    // if (document.body.classList.contains("admin-bar")) {
    //   document.querySelector('header').style.top = `${50}px`;
    // }
  }

  close () {
    super.close();
    document.querySelector('header').classList.remove('is-open');
    document.querySelector('html').classList.remove('no-scroll');

    if (this.label) {
      this.label.textContent = "Menu";
    }

    // if (document.body.classList.contains("admin-bar")) {
    //   document.querySelector('header').style.top = `0`;
    // }
  }

  mount () {
    super.mount();
    this.target.classList.add('has-burger');
    this.target.removeAttribute('tabindex');
    if (this.label) this.label.textContent = "Menu";
  }

  unmount () {
    super.unmount();
    this.target.classList.remove('has-burger');
    document.querySelector('html').classList.remove('no-scroll');
    document.querySelector('header').classList.remove('is-open');
    this.target.removeAttribute('tabindex');
    if (this.label) this.label.textContent = "Menu";
  }
}
